import React, { useMemo } from "react";
import GenericDialog from "components/Dialogs/GenericDialogV2";
import FormDropdown from "components/FormFields/FormDropdown";
import { useForm } from "react-hook-form";
import { useDataset } from "hooks/useDataset";
import { DATASET } from "utils/const";
import FormInputV2 from "components/FormFields/FormInputV2";
import GenericButton from "components/Buttons/GenericButton";
import { Box, Typography } from "@material-ui/core";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useParams } from "react-router-dom/cjs/react-router-dom.min";
import useMessage from "hooks/useMessage";
import { ConditionGuard } from "guards/ConditionGuard";
import { useDispatch } from "react-redux";
import { showGenericTwoButtonDialogAction } from "redux/actions/dialogsAction";
import { inactiveWorkCenterEmployee } from "crud/workCentersEmployer.crud";

const InactiveEmployeeModal = ({ open, handleClose, selectedWorkCenterEmployer, handleCloseDialog }) => {
  const { control, handleSubmit, watch } = useForm();

  const { id } = useParams();
  const { showSuccessMessage, showErrorMessage } = useMessage();
  const queryClient = useQueryClient();

  const dispatch = useDispatch();

  const showDialog = (message, submessage, yesAction, noAction) => {
    dispatch(showGenericTwoButtonDialogAction(message, submessage, yesAction, noAction));
  };

  const { data: INACTIVE_EMPLOYEE_MOTIVES } = useDataset({
    name: DATASET.INACTIVE_EMPLOYEE_MOTIVES,
  });

  const { mutateAsync: inactiveWorkCenterEmployeeMutation, isLoading: inactiveWorkCenterEmployeeLoading } = useMutation(
    ["inactiveEmployee", id],
    (data) => inactiveWorkCenterEmployee(data),
    {
      onSuccess: () => {
        showSuccessMessage("Trabalhador inactivo com sucesso.");

        queryClient.refetchQueries({
          queryKey: ["listWorkCenterEmployers"],
          exact: true,
        });
        handleClose();
        handleCloseDialog();
      },

      onError: () => {
        showErrorMessage("Ocorreu um erro ao inactivar o trabalhador!");
      },
    }
  );

  async function onSubmit(data) {
    const inactiveData = {
      id: selectedWorkCenterEmployer,
      motiveId: data.motiveId,
      otherMotiveDescription: data.otherMotiveDescription,
    };

    showDialog(
      "Inactivar Trabalhador",
      "Tem a certeza que deseja inactivar este trabalhador?",
      async () => {
        await inactiveWorkCenterEmployeeMutation(inactiveData);
        handleCloseDialog();
      },
      () => {}
    );
  }

  const showObservationInput = useMemo(() => {
    return INACTIVE_EMPLOYEE_MOTIVES?.find((motive) => motive.keyValue === "OTHER")?.code === watch("motiveId");
  }, [INACTIVE_EMPLOYEE_MOTIVES, watch("motiveId")]);

  return (
    <GenericDialog open={open} onClose={handleClose} fullWidth={true} maxWidth="sm">
      <Typography
        style={{
          fontSize: "1.6rem",
          marginBottom: "2rem",
        }}
        variant="h2"
        color="primary"
      >
        Inactivar Trabalhador
      </Typography>

      <form>
        <FormDropdown control={control} name="motiveId" label="Motivo da Saída" options={INACTIVE_EMPLOYEE_MOTIVES} />

        <ConditionGuard condition={showObservationInput}>
          <FormInputV2 control={control} name="otherMotiveDescription" label="Descrição" isMultiLine rows={4} />
        </ConditionGuard>

        <Box display="flex" justifyContent="flex-end" gridGap={12}>
          <GenericButton color="tertiary" onClick={handleClose}>
            Cancelar
          </GenericButton>
          <GenericButton onClick={handleSubmit(onSubmit)} color="primary" loading={inactiveWorkCenterEmployeeLoading}>
            Submeter
          </GenericButton>
        </Box>
      </form>
    </GenericDialog>
  );
};

export default InactiveEmployeeModal;
